import React, { useEffect } from 'react';
import { Modal } from 'src/components';
import ButtonGroup, { LayoutType } from 'src/components/button-group/button-group';
import { CloseIconDark } from 'src/assets/images';
import { ButtonParamType, DefaultButtonStyle } from 'src/components/button/button';
import { publicSiteUrl } from 'src/common';
import './underage-modal.scss';

export default function UnderageModal(props) {
  const swallowTabs = (e) => {
    if (e.key === 'Tab') {
      return false;
    }
  };

  useEffect(() => {
    if (props.show && document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
      document.onkeydown = swallowTabs;
    }

    return () => {
      document.onkeydown = () => {};
    };
  }, [props.show]);

  const getConfirmButton = () => {
    return {
      automationId: 'Onboarding_Choose_Solution_CV_Underage_Close_Application',
      buttonParams: {
        type: ButtonParamType.NormalButton,
        onClick: () => {
          props.onExitApplication();
          window.location.href = publicSiteUrl;
        },
      },
      label: 'Close application',
      buttonStyle: DefaultButtonStyle().hasPrimaryAction().isMediumSize().hasLightMode().build(),
      className: 'modal-button',
    };
  };

  return (
    <Modal
      modalStyle="UnderageModal"
      show={props.show}
      cardStyle="submit-modal-card"
      header={() => (
        <>
          <p className="modal-head heading-four has-text-centered">Please note</p>
          {props.onClose && (
            <img src={CloseIconDark} alt="X" className="close-icon" onClick={props.onClose} />
          )}
        </>
      )}
      headerStyle="submit-modal-card-head"
      body={() => (
        <p className="modal-body-text">
          You must be at least 18 years or older to register for this service.
        </p>
      )}
      bodyStyle="submit-modal-card-body has-text-centered"
      footer={() => (
        <ButtonGroup
          buttons={[getConfirmButton(props.onButtonClick)]}
          layoutType={LayoutType.CENTERED}
        />
      )}
      footerStyle="submit-modal-card-foot"
      backdropStyle="backdrop"
    />
  );
}
